import { Component, Output, EventEmitter, Renderer2, OnInit, OnDestroy, inject } from '@angular/core';

@Component({
  selector: 'app-word-cloud-wait-modal',
  templateUrl: './word-cloud-wait-modal.component.html',
  styleUrls: ['./word-cloud-wait-modal.component.scss'],
  standalone: false,
})
export class WordCloudWaitModalComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);

  @Output() closeFilter = new EventEmitter<any>();

  ngOnInit() {
    this.renderer.addClass(document.body, 'modal-open');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'modal-open');
  }

  onClose() {
    this.closeFilter.emit();
  }
}
